<template>
  <b-modal
    class="my-modal"
    title="Журнал действий"
    scrollable
    :visible="isOpen"
    size="lg"
    @hide="hideModal"
    hide-footer
  >
    <b-table class="table" striped hover :items="items"></b-table>
  </b-modal>
</template>

<script>
export default {
  data: () => ({
    isOpen: false,
    items: [
      {
        Пользователь: "Вася Пупкин",
        Действие: "Секретно",
        Снимок: "DS_DZHR1_202004010602151_KZ1_E071N51_002796",
        Дата: new Date().toLocaleDateString(),
        _rowVariant: "danger"
      },
      {
        Пользователь: "Вася Пупкин",
        Действие: "Не секретно",
        Снимок: "DS_DZHR1_202004010602151_KZ1_E071N51_002796",
        Дата: new Date().toLocaleDateString(),
        _rowVariant: "success"
      },
      {
        Пользователь: "Вася Пупкин",
        Действие: "Секретно",
        Снимок: "DS_DZHR1_202004010602151_KZ1_E071N51_002796",
        Дата: new Date().toLocaleDateString(),
        _rowVariant: "danger"
      },
      {
        Пользователь: "Вася Пупкин",
        Действие: "Не секретно",
        Снимок: "DS_DZHR1_202004010602151_KZ1_E071N51_002796",
        Дата: new Date().toLocaleDateString(),
        _rowVariant: "success"
      },
      {
        Пользователь: "Вася Пупкин",
        Действие: "Секретно",
        Снимок: "DS_DZHR1_202004010602151_KZ1_E071N51_002796",
        Дата: new Date().toLocaleDateString(),
        _rowVariant: "danger"
      },
      {
        Пользователь: "Вася Пупкин",
        Действие: "Не секретно",
        Снимок: "DS_DZHR1_202004010602151_KZ1_E071N51_002796",
        Дата: new Date().toLocaleDateString(),
        _rowVariant: "success"
      },
      {
        Пользователь: "Вася Пупкин",
        Действие: "Секретно",
        Снимок: "DS_DZHR1_202004010602151_KZ1_E071N51_002796",
        Дата: new Date().toLocaleDateString(),
        _rowVariant: "danger"
      },
      {
        Пользователь: "Вася Пупкин",
        Действие: "Не секретно",
        Снимок: "DS_DZHR1_202004010602151_KZ1_E071N51_002796",
        Дата: new Date().toLocaleDateString(),
        _rowVariant: "success"
      },
      {
        Пользователь: "Вася Пупкин",
        Действие: "Секретно",
        Снимок: "DS_DZHR1_202004010602151_KZ1_E071N51_002796",
        Дата: new Date().toLocaleDateString(),
        _rowVariant: "danger"
      },
      {
        Пользователь: "Вася Пупкин",
        Действие: "Не секретно",
        Снимок: "DS_DZHR1_202004010602151_KZ1_E071N51_002796",
        Дата: new Date().toLocaleDateString(),
        _rowVariant: "success"
      },
      {
        Пользователь: "Вася Пупкин",
        Действие: "Секретно",
        Снимок: "DS_DZHR1_202004010602151_KZ1_E071N51_002796",
        Дата: new Date().toLocaleDateString(),
        _rowVariant: "danger"
      },
      {
        Пользователь: "Вася Пупкин",
        Действие: "Не секретно",
        Снимок: "DS_DZHR1_202004010602151_KZ1_E071N51_002796",
        Дата: new Date().toLocaleDateString(),
        _rowVariant: "success"
      },
      {
        Пользователь: "Вася Пупкин",
        Действие: "Секретно",
        Снимок: "DS_DZHR1_202004010602151_KZ1_E071N51_002796",
        Дата: new Date().toLocaleDateString(),
        _rowVariant: "danger"
      },
      {
        Пользователь: "Вася Пупкин",
        Действие: "Не секретно",
        Снимок: "DS_DZHR1_202004010602151_KZ1_E071N51_002796",
        Дата: new Date().toLocaleDateString(),
        _rowVariant: "success"
      },
      {
        Пользователь: "Вася Пупкин",
        Действие: "Секретно",
        Снимок: "DS_DZHR1_202004010602151_KZ1_E071N51_002796",
        Дата: new Date().toLocaleDateString(),
        _rowVariant: "danger"
      },
      {
        Пользователь: "Вася Пупкин",
        Действие: "Не секретно",
        Снимок: "DS_DZHR1_202004010602151_KZ1_E071N51_002796",
        Дата: new Date().toLocaleDateString(),
        _rowVariant: "success"
      },
      {
        Пользователь: "Вася Пупкин",
        Действие: "Секретно",
        Снимок: "DS_DZHR1_202004010602151_KZ1_E071N51_002796",
        Дата: new Date().toLocaleDateString(),
        _rowVariant: "danger"
      },
      {
        Пользователь: "Вася Пупкин",
        Действие: "Не секретно",
        Снимок: "DS_DZHR1_202004010602151_KZ1_E071N51_002796",
        Дата: new Date().toLocaleDateString(),
        _rowVariant: "success"
      },
      {
        Пользователь: "Вася Пупкин",
        Действие: "Секретно",
        Снимок: "DS_DZHR1_202004010602151_KZ1_E071N51_002796",
        Дата: new Date().toLocaleDateString(),
        _rowVariant: "danger"
      },
      {
        Пользователь: "Вася Пупкин",
        Действие: "Не секретно",
        Снимок: "DS_DZHR1_202004010602151_KZ1_E071N51_002796",
        Дата: new Date().toLocaleDateString(),
        _rowVariant: "success"
      },
      {
        Пользователь: "Вася Пупкин",
        Действие: "Секретно",
        Снимок: "DS_DZHR1_202004010602151_KZ1_E071N51_002796",
        Дата: new Date().toLocaleDateString(),
        _rowVariant: "danger"
      },
      {
        Пользователь: "Вася Пупкин",
        Действие: "Не секретно",
        Снимок: "DS_DZHR1_202004010602151_KZ1_E071N51_002796",
        Дата: new Date().toLocaleDateString(),
        _rowVariant: "success"
      },
      {
        Пользователь: "Вася Пупкин",
        Действие: "Секретно",
        Снимок: "DS_DZHR1_202004010602151_KZ1_E071N51_002796",
        Дата: new Date().toLocaleDateString(),
        _rowVariant: "danger"
      },
      {
        Пользователь: "Вася Пупкин",
        Действие: "Не секретно",
        Снимок: "DS_DZHR1_202004010602151_KZ1_E071N51_002796",
        Дата: new Date().toLocaleDateString(),
        _rowVariant: "success"
      }
    ]
  }),
  methods: {
    showModal() {
      this.isOpen = true;
    },
    hideModal() {
      this.isOpen = false;
    }
  }
};
</script>

<style>
.modal {
  max-height: 80%;
  font-family: Arial, Helvetica, sans-serif;
}
.modal .modal-body {
  /* padding: 0 !important; */
}
.table {
  margin: 0 !important;
}
</style>
